export enum RCumLaudeModule {
	SECTIE = 'SECTIE',
	DOCENT = 'DOCENT',
	SCHOOLAANWEZIGHEID = 'SCHOOLAANWEZIGHEID',
}
